import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Do I need to be a Hector product expert?",
      answer: "No. Your job is to refer. Our onboarding team handles the rest. If they have questions, they ask us, not you."
    },
    {
      question: "What if someone signs up but doesn't use Hector?",
      answer: "You still get paid. Commission is whatever they're charged. If they cancel after 1 month, you still earned it."
    },
    {
      question: "Can I share my referral link on social media?",
      answer: "Absolutely. Email, LinkedIn, Twitter, Instagram, Slack communities, anywhere your network hangs out. Just no paid ads (yet)."
    },
    {
      question: "How do I know who to refer?",
      answer: "Anyone selling on Amazon. Agencies managing ads. Freelancers handling campaigns. Ex-employees consulting. Financial people auditing spend. If they work in the Amazon ecosystem, they probably have a pain point Hector solves."
    },
    {
      question: "Is there a minimum number of referrals I need to make?",
      answer: "No. You can refer 1 person or 100. No quotas. No pressure."
    },
    {
      question: "When do I get paid?",
      answer: "Commissions are paid monthly, 30 days after the customer's first charge. So if they sign up on Jan 1, you get paid Feb 1 for all activity in January."
    },
    {
      question: "What if the customer has a problem? Will it affect my commission?",
      answer: "Your commission is separate from their experience. Even if they have issues, you're paid for the referral. (We handle support, so issues get resolved fast anyway.)"
    },
    {
      question: "Can I refer the same person multiple times?",
      answer: "No. Referral is tracked by email. The person who refers them first gets the credit."
    },
    {
      question: "Is there a cap on how much I can earn?",
      answer: "Nope. We've had affiliates earn $100K+ annually. No ceiling."
    },
    {
      question: "Do you provide marketing materials?",
      answer: "Yes. Case studies, email templates, social graphics, demo videos, sales one-pagers, and webinar slides are customizable. DM and we'll send everything."
    },
    {
      question: "Can I use my own brand when referring?",
      answer: "Absolutely. We want you to. Testimonials sound better when they come from someone your network already knows and trusts."
    },
    {
      question: "What if I'm in a different country?",
      answer: "We currently focus on US-based affiliates (Amazon ecosystem), but we're expanding. Apply anyway, we might make an exception."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-hector-light-grey via-white to-hector-light-grey">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            Frequently Asked <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">Questions</span>
          </h2>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <i className="fas fa-chevron-down faq-icon"></i>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
